import React, { useEffect, useMemo, useRef } from 'react'
import PropTypes from 'prop-types'

import { useSetState, useDebounce } from '@campaignhub/react-hooks'
import useUsersV4 from '@hooks/useUsersV4'

import {
  Box, DashboardModule,
} from '@campaignhub/suit-theme'

import InfiniteLinkingTags from '@components/InfiniteLinkingTags'

const defaultState = {
  searchFilter: '',
}

const AccountManagerDetails = (props) => {
  const { clientForm } = props
  const [state, setState] = useSetState(defaultState)
  const { searchFilter } = state

  const debouncedSearchFilter = useDebounce(searchFilter, 300)

  const {
    entityState,
    entityState: {
      account_managers,
      account_manager_details,
    },
    setEntityState,
  } = clientForm

  const { filteredUsersV4: filteredAccountManagers, loading, hasMore, callbacks: { loadNextPage, loadInitialPage } } = useUsersV4({ searchFilter: debouncedSearchFilter, selectedFlags: 'Account_Manager' })

  useEffect(() => {
    loadInitialPage()
  }, [debouncedSearchFilter])

  const selectedCacheRef = useRef({})
  const selectedAccountManagers = useMemo(() => {
    if (!account_managers?.length) return []
    return account_managers.map((ref) => {
      const detail = account_manager_details?.find(d => ref === `User/${d.id}`)
      if (detail) selectedCacheRef.current[ref] = { ...detail, reference: ref }
      return selectedCacheRef.current[ref] || { id: ref, reference: ref, name: ref }
    })
  }, [account_managers, account_manager_details])

  const toggleAccountManager = (accountManager, type) => {
    if (type === 'add'){
      selectedCacheRef.current[accountManager.reference] = accountManager
      setEntityState({ account_managers: [...(account_managers || []), accountManager.reference] })
    } else {
      setEntityState({ account_managers: (account_managers || []).filter(ref => ref !== accountManager.reference) })
    }
  }

  useEffect(() => {
    if (entityState.id === null) setEntityState({ account_managers: [] })
  }, [])

  return (
    <DashboardModule title="Account Manager" boxProps={{ marginBottom: 'large' }}>
      <Box flexDirection="column" padding="large">
        <Box flexDirection={['column', 'row']} marginBottom="large">
          <InfiniteLinkingTags
            label="Users"
            options={filteredAccountManagers}
            selectedItems={selectedAccountManagers}
            onSelect={item => toggleAccountManager(item, 'add')}
            onRemove={item => toggleAccountManager(item)}
            onLoadMore={loadNextPage}
            hasMore={hasMore}
            loading={loading}
            placeholder="Search Users"
            labelKey="name"
            valueKey="id"
            searchFilter={searchFilter}
            onSearchChange={val => setState({ searchFilter: val })}
            showEmptyText={false}
          />
        </Box>
      </Box>
    </DashboardModule>
  )
}

AccountManagerDetails.propTypes = {
  clientForm: PropTypes.object,
}

export default AccountManagerDetails
